var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuote({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9 11.726C7.183 13.063 6.292 14.154 5.225 15l-.875-.736c.417-.525.783-1.193 1.1-2.005.333-.812.517-1.65.55-2.513a2.456 2.456 0 01-1.425-.787A2.316 2.316 0 014 7.386c0-.694.225-1.26.675-1.7C5.142 5.227 5.733 5 6.45 5c.75 0 1.358.245 1.825.736.483.49.725 1.21.725 2.157 0 1.202-.367 2.48-1.1 3.833zM21 6a1 1 0 01-1 1h-8a1 1 0 110-2h8a1 1 0 011 1zm-4 4a1 1 0 01-1 1h-4a1 1 0 110-2h4a1 1 0 011 1zm4 4.002a1 1 0 01-1 1h-8a1 1 0 110-2h8a1 1 0 011 1zm-5 5a1 1 0 100-2h-4a1 1 0 000 2h4z"
  })));
}

export default SvgQuote;